import View from '../../../Core/View.js';

class SailingRules extends View {

	static CLASS_STATE_VISIBLE = 'sailing-rules__per-location--visible';

	/**
	 *
	 */
	initialize() {
		this.dropdownMenu = this.$el.find('.sailing-rules__dropdown__select').get(0);
		this.$rulesLists = this.$el.find('.sailing-rules__per-location');

		this.dropdownMenu.addEventListener('change', this.getDropdownChoice.bind(this));

		this.getDropdownChoice();
	}

	/**
	 *
	 * @returns {Array}
	 */
	getDropdownChoice() {
		const $prevList = this.$rulesLists.filter(':visible');
		const $ruleList = this.$rulesLists.filter('[data-location="' + this.dropdownMenu.value + '"]');

		$prevList.removeClass(SailingRules.CLASS_STATE_VISIBLE);
		$ruleList.addClass(SailingRules.CLASS_STATE_VISIBLE);
	}
}

export default SailingRules;


// WEBPACK FOOTER //
// ./js/Views/Modules/SailingRules/SailingRules.js